<div>
    <app-server-provider-form></app-server-provider-form>
</div>
<div>
    <app-server-provider-list></app-server-provider-list>
</div>

